module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e289"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c7_r1#d12e156",
      "id": "d12e290"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e292"
    }
  }, [_vm._v("What person had the most profound impact on your faith?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e294"
    }
  }, [_vm._v("Who was the person in your life whose actions and words best reflected the Lord?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e296"
    }
  }, [_vm._v("In whose eyes did you first see Jesus?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e298"
    }
  }, [_vm._v("They say the eyes are a window to the soul. Over the past fifteen years I have had the opportunity to interview a number of people and ask them, “In whose eyes did you first see Jesus?” The stories they have told me have been fascinating and inspiring. These stories have given me glimpses into the foundation of the faith of people who have changed my life. I hope and pray their stories will impact you as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e300"
    }
  }, [_vm._v("The heroes found in these pages are some of the greatest voices in the Christian world. When you get to know these heroes of the faith, you will discover that they reflect what they saw and learned from others who mirrored Jesus. Thus, while each chapter is a single individual’s testimony, each chapter is also the story of the witness who was behind that hero’s call to faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e302"
    }
  }, [_vm._v("In these pages you will find the story of a Sunday school teacher who reached out to a quadriplegic, and, in the process, changed the whole world. You’ll see the impact of grandfathers, grandmothers, aunts, mothers, and fathers on the lives of young children who would later become well-known singers, businesspeople, and writers. And you’ll see how even the prayers of little-known neighbors and strangers made a profound difference in one woman’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e304"
    }
  }, [_vm._v("Thanks to Zondervan, I was able bring these special stories to life. Now you can read about the faithful everyday believers who inspired some of the world’s best-known and most- influential Christian voices. You can see how a simple touch, a look, or a word dramatically changed the world. You can even come to realize that if you put your faith into action, others will see it and want to embrace that faith as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e306"
    }
  }, [_vm._v("I think these stories will inspire and move you. I believe you will enjoy this book and come to a greater understanding of the heroes profiled here. Yet I hope that something else also happens as you read "), _c('i', [_vm._v("I Saw Him in Your Eyes")]), _vm._v(". I pray that you will remember the person in whose eyes you first saw Jesus. Then I pray that the next person who looks into your face will say, “I saw Him in your eyes.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3b9d70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coll_ISBN0310862558_epub_c8_r1.vue
// module id = 75
// module chunks = 0